import React, { Component } from "react";
import {
  Layout,
  Row,
  Col,
  List,
  Button,
  Tag,
  Spin,
  Modal,
  message,
  Collapse
} from "antd";
import { WhiteSpace } from "peak-design";
import Cookies from "universal-cookie";
import axios from "axios";
import ResizeAware from "react-resize-aware";
import styles from "./styles/results.module.scss";

//components
import { PageTitle } from "../../components/common";
import { ClinicalTrialItem } from "../../components/items";
import { PatientInfoForm } from "../../components/forms";

//data
import { recruitmentOptions } from "../../data";

const { Sider, Content } = Layout;
const Panel = Collapse.Panel;
const API_URL = process.env.REACT_APP_API_URL;

class Results extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      fetchingValues: true,
      collapsed: true,
      editVisible: true,
      modalVisible: false,
      subscribed: false,
      signingUp: false,
      updating: false
    };
  }
  componentDidMount() {
    if (!this.props.history.location.state.results)
      this.props.history.push("/search/existing");
    const cookies = new Cookies();
    const clientId = cookies.get("fasttrek-client");
    axios
      .get(`${API_URL}/client/${clientId}`)
      .then(res => {
        this.setState({ fetchingValues: false, clientValues: res.data });
      })
      .catch(err => console.log(err));
  }
  handleResize = ({ width, height }) => {
    window.parent.postMessage(height, "*");
  };
  renderSearchCriteria = () => {
    const searchCriteria = this.props.history.location.state.values;
    return Object.keys(searchCriteria).map(key => {
      if (
        searchCriteria[key] &&
        key !== "clinicalTrialsExtraStates" &&
        key !== "clinicalTrialsStudyStatus"
      )
        return (
          <Tag>
            {key.substring(14)}:{" "}
            {key === "clinicalTrialsState"
              ? searchCriteria[key].substring(5)
              : searchCriteria[key]}
          </Tag>
        );
      else if (key === "clinicalTrialsStudyStatus" && searchCriteria[key]) {
        let value = "";
        let count = searchCriteria[key].length;
        searchCriteria[key].forEach(status => {
          count -= 1;
          let obj = recruitmentOptions.filter(obj => {
            return obj.value === status;
          });
          value += obj[0].label;
          if (count !== 0) value += "; ";
        });
        return <Tag>Study Status: {value}</Tag>;
      } else if (key === "clinicalTrialsExtraStates" && searchCriteria[key]) {
        let value = "";
        let count = searchCriteria[key].length;
        searchCriteria[key].forEach(state => {
          count -= 1;
          value += state.substring(5);
          if (count !== 0) value += ", ";
        });
        return <Tag>Additional States: {value}</Tag>;
      } else return null;
    });
  };
  renderActiveCriteria = () => {
    const { activeReport } = this.state.clientValues;
    return Object.keys(activeReport).map(key => {
      if (
        activeReport[key] &&
        key !== "activeReportExtraStates" &&
        key !== "activeReportStudyStatus"
      )
        return (
          <div>
            <strong>{key.substring(12)}:</strong>{" "}
            {key === "activeReportState"
              ? activeReport[key].substring(5)
              : activeReport[key]}
          </div>
        );
      else if (key === "activeReportStudyStatus" && activeReport[key]) {
        let value = "";
        let count = activeReport[key].length;
        activeReport[key].forEach(status => {
          count -= 1;
          let obj = recruitmentOptions.filter(obj => {
            return obj.value === status;
          });
          value += obj[0].label;
          if (count !== 0) value += "; ";
        });
        return (
          <div>
            <strong>Study Status:</strong> {value}
          </div>
        );
      } else if (key === "activeReportExtraStates" && activeReport[key]) {
        let value = "";
        let count = activeReport[key].length;
        activeReport[key].forEach(state => {
          count -= 1;
          value += state.substring(5);
          if (count !== 0) value += ", ";
        });
        return (
          <div>
            <strong>Additional States:</strong> {value}
          </div>
        );
      } else return null;
    });
  };
  handleSubmit = (e, form) => {
    e.preventDefault();
    this.setState({ loading: true });
    form.validateFields((err, values) => {
      if (!err) {
        const cookies = new Cookies();
        const clientValues = values;
        const sendToClient = false;
        const clientId = cookies.get("fasttrek-client");
        axios
          .post(`${API_URL}/generate_report`, {
            clientValues,
            sendToClient,
            clientId
          })
          .then(res => {
            this.setState({ loading: false });
            this.props.history.push("/results", {
              results: res.data,
              values: clientValues
            });
          })
          .catch(err => {
            this.setState({ loading: false });
            console.log(err);
          });
      }
    });
  };
  toggleSider = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };
  onBroken = broken => {
    if (broken) this.setState({ collapsed: true, editVisible: true });
    else this.setState({ collapsed: false, editVisible: false });
  };
  showConfirm = () => {
    const searchCriteria = this.props.history.location.state.values;
    Modal.confirm({
      title: "Are you sure you would like to receive weekly updates?",
      content:
        "By clicking confirm, you are opting-in to weekly email updates that will include clinical trial reports matching your search.",
      okText: "Confirm",
      onOk: () => {
        this.setState({ signingUp: true });
        const cookies = new Cookies();
        const clientId = cookies.get("fasttrek-client");
        const clientValues = { ...this.state.clientValues };
        Object.keys(searchCriteria).forEach(key => {
          const newKey = `activeReport${key.slice(14)}`;
          clientValues.activeReport[newKey] = searchCriteria[key];
        });
        const values = {
          clientId,
          activeReport: clientValues.activeReport,
          sendToClient: true
        };
        console.log(values);
        axios
          .post(`${API_URL}/activate_report`, values)
          .then(res => {
            this.setState({
              subscribed: true,
              signingUp: false,
              clientValues: clientValues
            });
            message.success(
              "You have successfully signed up to receive updates."
            );
          })
          .catch(err => {
            console.log(err);
            message.error("Something went wrong...");
          });
      },
      onCancel() {
        console.log("Cancel");
      }
    });
  };
  showUpdateReport = () => {
    const searchCriteria = this.props.history.location.state.values;
    Modal.confirm({
      title: "Are you sure you would like to update your active report?",
      content:
        "Please note: we can only provide 1 active report per username or email. The criteria for the active report and the date on which that criteria is based is displayed in the active report dropdown. By clicking confirm, you are updating your active report to reflect the current search criteria.",
      okText: "Confirm",
      onOk: () => {
        this.setState({ updating: true });
        const cookies = new Cookies();
        const clientId = cookies.get("fasttrek-client");
        const activeReport = {};
        const clientValues = { ...this.state.clientValues };
        Object.keys(searchCriteria).forEach(key => {
          const newKey = `activeReport${key.slice(14)}`;
          clientValues.activeReport[newKey] = searchCriteria[key];
        });
        const values = {
          clientId,
          activeReport: clientValues.activeReport,
          sendToClient: true
        };
        console.log(values);
        axios
          .post(`${API_URL}/activate_report`, values)
          .then(res => {
            this.setState({ updating: false, clientValues });
            message.success(
              "You have successfully updated your active report."
            );
          })
          .catch(err => {
            message.error("Something went wrong...");
          });
      },
      onCancel() {
        console.log("Cancel");
      }
    });
  };
  showUnsubscribe = () => {
    Modal.confirm({
      title: "Are you sure you would like to unsubscribe from weekly updates?",
      content:
        "By clicking confirm, you are opting-out of weekly email updates.",
      okText: "Confirm",
      onOk: () => {
        const cookies = new Cookies();
        const clientId = cookies.get("fasttrek-client");
        const values = { _id: clientId, subscribed: false };
        axios
          .put(`${API_URL}/client`, values)
          .then(res => {
            this.setState({ subscribed: false });
            message.success("You have successfully unsubscribed from updates.");
          })
          .catch(err => {
            console.log(err);
            message.error("Something went wrong...");
          });
      },
      onCancel() {
        console.log("Cancel");
      }
    });
  };
  render() {
    const newTrials = this.props.history.location.state.results.reports
      .clinicalTrialsUpdates;
    const searchCriteria = this.props.history.location.state.values;
    const {
      loading,
      fetchingValues,
      editVisible,
      collapsed,
      clientValues
    } = this.state;
    return (
      <ResizeAware onResize={this.handleResize} onlyEvent>
        <Layout className={styles.container}>
          <Sider
            width={editVisible ? "100%" : 450}
            collapsedWidth={0}
            breakpoint={"lg"}
            theme="light"
            trigger={null}
            collapsed={collapsed}
            onBreakpoint={broken => this.onBroken(broken)}
          >
            <div className={styles.sider}>
              <div className={styles.siderFormContainer}>
                {editVisible && !collapsed ? (
                  <div style={{ textAlign: "center", marginTop: -20 }}>
                    <Button
                      type="secondary"
                      onClick={() => this.setState({ collapsed: !collapsed })}
                    >
                      Collapse Menu
                    </Button>
                    <WhiteSpace height={20} />
                  </div>
                ) : null}
                <div className={styles.siderForm}>
                  {(!fetchingValues && clientValues.subscribed) ||
                  this.state.subscribed ? (
                    <div className={styles.siderFormPadding}>
                      <PageTitle title="You are currently signed up to receive email updates:" />
                      <Collapse bordered={false}>
                        <Panel
                          header="View Active Report Criteria"
                          className={styles.collapseItem}
                        >
                          {this.renderActiveCriteria()}
                        </Panel>
                      </Collapse>
                      <Button
                        type="primary"
                        size="large"
                        loading={this.state.updating}
                        onClick={this.showUpdateReport}
                      >
                        Update Report
                      </Button>
                      <Button
                        type="secondary"
                        size="large"
                        onClick={this.showUnsubscribe}
                        style={{ float: "right" }}
                      >
                        Unsubscribe
                      </Button>
                    </div>
                  ) : (
                    <div className={styles.siderFormPadding}>
                      <PageTitle title="Want Updated Reports Sent to Your Email?" />
                      <Button
                        type="primary"
                        size="large"
                        loading={this.state.signingUp}
                        onClick={this.showConfirm}
                      >
                        Sign Up Now
                      </Button>
                    </div>
                  )}
                </div>
                <WhiteSpace height={40} />
                <div className={styles.siderForm}>
                  <div className={styles.siderFormPadding}>
                    <PageTitle title="Edit Existing Search" />
                    <PatientInfoForm
                      handleSubmit={(e, form) => this.handleSubmit(e, form)}
                      loading={loading}
                      isNew={false}
                      fetchingValues={fetchingValues}
                      existingValues={searchCriteria}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Sider>
          <Content
            className={styles.content}
            style={!collapsed ? { paddingLeft: 0 } : {}}
          >
            <Row type="flex" justify="center" align="top">
              <Col xs={{ span: 22 }} md={{ span: 24 }}>
                <div style={{ float: "right" }}>
                  <Button type="primary" href="/search/new">
                    New Search
                  </Button>
                  {editVisible ? <WhiteSpace width={10} /> : null}
                  {editVisible ? (
                    <Button type="secondary" onClick={this.toggleSider}>
                      More Options
                    </Button>
                  ) : null}
                </div>
                <div className={styles.pageTitle}>
                  <PageTitle
                    title={`We found ${
                      newTrials.length
                    } studies matching your search`}
                  />
                </div>
                <h3>Search criteria:</h3>
                <div>{this.renderSearchCriteria()}</div>
                <WhiteSpace height={20} />
                <List
                  itemLayout="horizontal"
                  dataSource={newTrials}
                  pagination
                  renderItem={trial => (
                    <ClinicalTrialItem key={trial.nct_id} trial={trial} />
                  )}
                />
                <WhiteSpace height={50} />
              </Col>
            </Row>
          </Content>
          {loading ? (
            <div className={styles.loadingContainer}>
              <Spin size="large" tip="Generating new reports..." />
            </div>
          ) : null}
        </Layout>
      </ResizeAware>
    );
  }
}

export { Results };



// WEBPACK FOOTER //
// ./src/containers/pages/Results.js